export default __webpack_public_path__ + "static/media/man.4f86165c.png";